<template>
    <ModalIndex
        v-model:visible="showDeleteModal"
        :eventToCloseFunction="clearDeleteRef"
        footer-class="justify-end"
        fullscreen-on-mobile
        title="Delete EMD"
    >
        <p
            v-if="error"
            class="text-danger rounded-md bg-ds-red-100 px-6 py-4 text-base"
        >
            There was an error deleting this record. Please try again, or contact support if you continue to experience the
            problem.
        </p>

        <div class="grid grid-cols-2 gap-y-2">
            <span>Property Address</span>
            <span>{{ deleteEmdRef!.address }}</span>

            <span>Clients</span>
            <ul>
                <li
                    v-for="client in deleteEmdRef!.clients"
                    :key="client.id"
                    class="list-none text-base"
                >
                    {{ client.email }}
                </li>
            </ul>

            <span>Deposit Amount</span>
            <span>{{ formatMoney((deleteEmdRef!.deposit_amount ?? 0) / 100) }}</span>
        </div>

        <template #footer>
            <button
                class="bg-danger rounded-md px-6 py-4 text-white"
                :disabled="!deleteEmdRef"
                @click="confirmDelete"
            >
                Confirm
            </button>
            <button
                class="rounded-md px-6 py-4"
                @click="clearDeleteRef"
            >
                Cancel
            </button>
        </template>
    </ModalIndex>
</template>

<script setup lang="ts">
import type { EarlyDeposit } from '@/api/interfaces/early-deposit-types';
import ModalIndex from '@/components/Components/Modal/ModalIndex.vue';
import { useDeleteEarlyDeposit } from '@/services/early-deposit.service';
import { formatMoney } from '@/shared/utils/format-number';
import { computed } from 'vue';

const showDeleteModal = computed<boolean>({
    get: () => !!deleteEmdRef.value,
    set: flag => {
        !flag && clearDeleteRef();
    },
});
const emit = defineEmits<{
    emdDeleted: [emdId: EarlyDeposit['id']];
}>();

const { error, deleteEmdRef, clearDeleteRef, runDelete } = useDeleteEarlyDeposit();

const confirmDelete = async () => {
    await runDelete();
    if (error.value) return;
    emit('emdDeleted', deleteEmdRef.value!.id);
    clearDeleteRef();
};
</script>
